import { connect } from 'react-redux';
import { changeEbookReaderOpenRoutine, resetPlayerRoutine, updateEBookDataRoutine } from 'redux-state/ducks/player';
import PDFReader from './pdf-reader.component';

const mapStateToProps = ({ app, player }) => ({
  config: app.config,
  queue: player.queue,
  ebookData: player.ebookData,
  activeIndex: player.activeIndex,
});

const mapDispatchToProps = {
  resetPlayerAction: resetPlayerRoutine.request,
  updateEBookDataAction: updateEBookDataRoutine.request,
  changeEbookReaderOpenAction: changeEbookReaderOpenRoutine.request,
};

export default connect(mapStateToProps, mapDispatchToProps)(PDFReader);
